import { defineComponent as _defineComponent } from 'vue'
import type { Component } from 'vue';
import AboutCard from './AboutCard.vue';
import AboutCardText from './AboutCardText.vue';

interface Props {
  data: {
    title: string;
    cols: Array<
      Array<{
        type: string;
        title?: string;
        description?: string;
        color?: string;
        image?: {
          src?: string;
        };
        link?: {
          text?: string;
          url?: string;
        };
      }>
    >;
  };
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AboutCards',
  props: {
    data: null
  },
  setup(__props: any) {



const cardComponents: Record<string, Component> = {
  'about-card': AboutCard,
  'about-card-text': AboutCardText,
};

return { __sfc: true,cardComponents }
}

})